import React from 'react';
import {withRouter, RouteComponentProps} from 'react-router';

import SearchFilter from 'components/Filters/SearchFilter';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<
  SubNavigationProps & RouteComponentProps<{locationRef: string}>
> {
  render() {
    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered">
        <SearchFilter
          value={this.props.filters.search}
          onChange={(search: string) => this.props.setFilter('search', search)}
        />
      </div>
    );
  }
}

export default withRouter(SubNavigation) as React.ComponentType<
  SubNavigationProps
>;
